<template>
  <section id="ContactFooter">
    <div class="main_container">
      <header class="section_header">
        <div class="text_box">
          <p class="title">Contact Us</p>
          <h3 class="sub_title">聯絡我們</h3>
          <p class="content">
            有任何疑問歡迎隨時使用線上客服或電話與我們聯繫，我們將盡快回覆您的問題。
          </p>
        </div>
        <div class="info_box">
          <p class="phone_number">
            {{ $store.getters.columnData("company_phone") }}
          </p>
          <p class="business_hours">
            {{ $store.getters.columnData("company_time") }}
          </p>
          <i class="content_line"></i>
          <div class="action_box">
            <a
              :href="$store.getters.columnData('company_line')"
              target="_blank"
              class="main_button"
              >線上客服
              <span class="icon material-symbols-rounded"> east </span>
              <span class="bg_box"></span>
              <span class="shadow_box"></span
            ></a>
          </div>
        </div>
      </header>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactFooter",
};
</script>
